import React from 'react';
import CostCenter from 'components/Tvendo/Shopping/DataMaster/CostCenter/CostCenter.js';

export default function () {
  return <CostCenter />;
}
